import flatBuildOrdersControls from '@apphiveio/controlsmanager/functions/flatters/flatBuildOrdersControls'
// THIS VALUES ARE USED DURING CLIENT APP COMPILATION, PLEASE DO NOT MOVE
const initialAppId = 'app_r7ggB54YTcrfk1vv1yrBxR'
const initialProjectId = 'proj_n9zjk6CjERri6F54tK3UK7'
const initialBuildOrdersOnApp = require('./buildOrders.loaded.json') // eslint-disable-line
const initialRunningMode = 'premium'
const initialCustomFontName = undefined
// #################

export const initialAppState = {
    appId: initialAppId,
    projectId: initialProjectId,
    buildOrders: initialBuildOrdersOnApp,
    runningMode: initialRunningMode,
    customFontName: initialCustomFontName,
} as const
